import React, { Component } from "react";
import _ from 'lodash';
import styles from "assets/jss/material-dashboard-pro-react/components/tableStyle";
import withStyles from "@material-ui/core/styles/withStyles";
import { connect } from "react-redux";
import { updateTopPickOverride, getGlobalProduct, updateRecommendationAttributes } from "../../../api/index";
import {
  AppBar,
  Checkbox,
  Dialog,
  IconButton,
  InputAdornment,
} from "@material-ui/core";
import RegularButton from "../../../components/CustomButtons/Button";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import margin from "assets/scss/custom/margin.module.scss";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import padding from "../../../assets/scss/custom/padding.module.scss";
import MySmallSelect from "../ItemDetailDrawer/MySmallSelect";
import Check from "@material-ui/icons/Check";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import RemoveCircleIcon from "@material-ui/icons/RemoveCircle";
const RECOMMENDATION_ATTRIBUTES = ['rec_user','rec_fbt','rec_checkout','rec_similar']
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

class GlobalProductModal extends Component {
  state = {
    base_category: {},
    product: {},
    tabIndex: 0,
  };
  handleClose() {
    this.props.closeGlobalProductModal();
  }
  loadProduct() {
    this.setState({ loading: true }, () => {
      getGlobalProduct(this.props.skuId)
        .then((res) => {
          if ( res.data.product.top_pick_override) {
            res.data.product.top_pick_override =  res.data.product.top_pick_override.map(
              (tpo) => {
                tpo.no_min = !tpo.min_aov;
                tpo.no_max = !tpo.max_aov;
                return tpo;
              }
            );
          }

          let productData = res.data.product;
          let algoliaAttr = {};
          if(_.isArray(productData.recommendation_override)){
            for(let recData of productData.recommendation_override){
              if(_.includes( RECOMMENDATION_ATTRIBUTES, recData.attribute)){
                algoliaAttr[recData.attribute] = recData.ordinal;
              }
            }
          }
          if(!_.isEmpty(algoliaAttr)){
            productData = _.merge(productData, algoliaAttr);
            delete productData.recommendation_override;
          }
          this.setState({ product: productData, base_category: res.data.base_category, loading: false });
        })
        .catch((err) => {
          this.setState({ loading: false });
        });
    });
  }
  componentDidMount() {
    this.loadProduct();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.skuId !== this.props.skuId) {
      this.loadProduct();
    }
  }

  addOverride = () => {
    let { product } = this.state;
    let { top_pick_override } = product;
    top_pick_override.push({
      min_aov: 0,
      max_aov: 0,
      no_min: true,
      no_max: true,
      position: 1,
    });
    product.top_pick_override = top_pick_override;
    this.setState({ product, amSoDirty: true, saved: false });
  };
  addRecAttribute = (attr) => {
    let { product } = this.state;
    product[attr] = 1;
    this.setState({ product, amSoDirty: true, saved: false });
  }

  handleTopPickToggle = (idx, field, e) => {
    let { product } = this.state;
    let { top_pick_override } = product;

    top_pick_override[idx][field] = !top_pick_override[idx][field];
    product.top_pick_override = top_pick_override;

    this.setState({ product, amSoDirty: true, saved: false }, () => {
      if(top_pick_override[idx][field]){
        this.handleUpdateTopPickField(idx, field.replace('no_','')+'_aov', 0)
      }
    });
  };

  handleUpdateTopPickField = (idx, field, val) => {
    let { product } = this.state;
    let { top_pick_override } = product;

    top_pick_override[idx][field] = val;

    product.top_pick_override = top_pick_override;
    this.setState({ product, amSoDirty: true, saved: false });
  };
  handleRecUpdate = (field, value) => {
    let { product } = this.state;
    product[field] = value;
    this.setState({ product, amSoDirty: true, saved: false });
  }
  placementTab = (topPickOverride) => {
    const { classes } = this.props;
    const { base_category } = this.state;
    return (
      <div style={{ marginTop: 10 }}>
        <div style={{ fontWeight: "bold", paddingBottom: 20 }}>Curated Top Pick Placement</div>
        {base_category &&  (
          <span>
            If the user’s average purchase price for{" "}
            <span style={{ fontWeight: "bold" }}>
              {base_category.name}
            </span>{" "}
            is between...
          </span>
        )}
            {(topPickOverride || []).map((prop, key) => {
              let data = [
                <IconButton
                  onClick={() => {
                    let { product } = this.state;
                    let { top_pick_override } = product;
                    top_pick_override.splice(key, 1);
                    product.top_pick_override = top_pick_override;
                    this.setState({ product, amSoDirty: true, saved: false });
                  }}
                >
                  <RemoveCircleIcon style={{ color: "red" }} />
                </IconButton>,
              ];
              data.push(
                <div style={{ display: "flex", gap: 5,  alignItems: "center" }}>
                  <div>
                    <span>
                      <Checkbox
                        checked={prop.no_min}
                        onClick={(e) =>
                          this.handleTopPickToggle(key, "no_min", e)
                        }
                        checkedIcon={<Check className={classes.checkedIcon} />}
                        icon={<Check className={classes.uncheckedIcon} />}
                        classes={{
                          checked: classes.checked,
                          root: classes.checkRoot,
                        }}
                      />
                      No Min
                    </span>
                  </div>
                  <div style={{ flex: 1 }}>
                    <MySmallSelect
                      value={prop.min_aov}
                      select={false}
                      label="Min APV"
                      price={prop.min_aov}
                      disabled={prop.no_min}
                      onChange={(e) =>
                        this.handleUpdateTopPickField(
                          key,
                          "min_aov",
                          e.target.value
                        )
                      }
                      style={{ width: 100 }}
                      className={padding.bottom_sm}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">$</InputAdornment>
                        ),
                      }}
                    ></MySmallSelect>
                  </div>
                </div>
              );
              data.push(" and ");
              data.push(
                <div style={{ display: "flex", gap: 5, alignItems: "center" }}>
                  <div>
                    <span>
                      <Checkbox
                        checked={prop.no_max}
                        onClick={(e) =>
                          this.handleTopPickToggle(key, "no_max", e)
                        }
                        checkedIcon={<Check className={classes.checkedIcon} />}
                        icon={<Check className={classes.uncheckedIcon} />}
                        classes={{
                          checked: classes.checked,
                          root: classes.checkRoot,
                        }}
                      />
                      No Max
                    </span>
                  </div>
                  <div style={{ flex: 1 }}>
                    <MySmallSelect
                      value={prop.max_aov}
                      select={false}
                      label="Max APV"
                      price={prop.max_aov}
                      disabled={prop.no_max}
                      onChange={(e) =>
                        this.handleUpdateTopPickField(
                          key,
                          "max_aov",
                          e.target.value
                        )
                      }
                      className={padding.bottom_sm}
                      style={{ width: 100 }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">$</InputAdornment>
                        ),
                      }}
                    ></MySmallSelect>
                  </div>
                </div>
              );
              data.push(", force this product to be at position ");

              data.push(
                <Select
                  autoWidth
                  value={prop.position}
                  multiple={false}
                  onClick={(e) =>
                    this.handleUpdateTopPickField(
                      key,
                      "position",
                      e.target.value
                    )
                  }
                  // onClick={onClick}
                  MenuProps={{ className: classes.selectMenu }}
                  classes={{ select: classes.select }}
                  inputProps={{
                    name: "multipleSelect",
                    id: "multiple-select",
                  }}
                >
                  {[
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7,
                    8,
                    9,
                    10,
                    11,
                    12,
                    13,
                    14,
                    15,
                    16,
                    17,
                    18,
                    19,
                    20,
                  ].map((option, i) => {
                    return (
                      <MenuItem
                        key={`position_${key}_${i}`}
                        classes={{
                          root: classes.selectMenuItem,
                          selected: classes.selectMenuItemSelectedMultiple,
                        }}
                        value={option}
                      >
                        {option}
                      </MenuItem>
                    );
                  })}
                </Select>
              );
              data.push("in the top picks recommendations")

              return (
                <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                  {data}
                </div>
              );
            })}

            <RegularButton
              onClick={() => this.addOverride()}
              color="success"
              disabled={!base_category.name}
            >
              <AddCircleIcon
                style={{ color: "green", verticalAlign: -7 }}
              />
              <span> Add New Override</span>
            </RegularButton>
      </div>
    );
  };
  recommendedTab = (recOptions) => {
    const { classes} = this.props;
    const { product } = this.state;
    let attrValue = product[recOptions.attribute];
    let numberRange = [];
    for(var i = 1; i <= 20; i++){
      numberRange.push(i)
    }
    
    return (
      <div style={{ marginTop: 10 }}>
        <div style={{ fontWeight: "bold", paddingBottom: 20 }}>{recOptions.name} Placement</div>
            {_.isNumber(attrValue) && (
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <IconButton
                  onClick={() => {
                    let { product } = this.state;
                    delete product[recOptions.attribute];
                    this.setState({ product, amSoDirty: true, saved: false });
                  }}
                >
                  <RemoveCircleIcon style={{ color: "red" }} />
                </IconButton>
              Force this product to be at position 
                <Select
                  autoWidth
                  value={attrValue}
                  multiple={false}
                  onClick={(e) =>
                    this.handleRecUpdate(
                      recOptions.attribute,
                      e.target.value
                    )
                  }
                  // onClick={onClick}
                  MenuProps={{ className: classes.selectMenu }}
                  classes={{ select: classes.select }}
                  inputProps={{
                    name: "multipleSelect",
                    id: "multiple-select",
                  }}
                >
                  {numberRange.map((option, i) => {
                    return (
                      <MenuItem
                        key={i}
                        classes={{
                          root: classes.selectMenuItem,
                          selected: classes.selectMenuItemSelectedMultiple,
                        }}
                        value={option}
                      >
                        {option}
                      </MenuItem>
                    );
                  })}
                </Select>
              in {recOptions.display}
              </div>
            )}
            {attrValue == undefined && 
              <RegularButton
                onClick={() => this.addRecAttribute(recOptions.attribute)}
                color="success"
              >
                
                <AddCircleIcon
                  style={{ color: "green", verticalAlign: -7 }}
                />
                <span> Add New </span>
              </RegularButton>
            } 
      </div>
    );
  };

  handleUpdateProduct = () => {
    const { product } = this.state;
    
    updateTopPickOverride(product.sku_id, product.top_pick_override)
    .then(()=>{
      return updateRecommendationAttributes(product.sku_id, product)
    })
    .then(() => {
      this.setState({ saved: true, amSoDirty: false });
    });
  };

  render() {
    const recommendationOptions = [
      {
        name:'Global',
        attribute:'rec_user',
        display:'(Top Picks for {Name})',
      },
      {
        name:'Checkout',
        attribute:'rec_checkout',
        display:'Displays at Checkout',
      },
      {
        name:'User May Also Like',
        attribute:'rec_similar',
        display:'(You May Also Like) - Web Only',
      },
      {
        name:'Product Page',
        attribute:'rec_fbt',
        display:'(Often Bought With) section',
      }
    ];
    const tabNames = [
      "Global Top Picks", "Checkout Recommendations", "User May Also Like",  "Product Page", "Custom Top Picks"
    ]
    const { classes } = this.props;
    const { product, tabIndex, amSoDirty, saved } = this.state;
    return (
      <Dialog maxWidth={"xl"} fullWidth open={true}>
        <div className={classes.container}>
          <div className={classes.details}>
            <div className={classes.leftContainer}>
              <img src={product.image} />
              {product.sku_id}
              <br />
              {product.title}
              <br />
              {product.subtitle}<br />
              {product.volume}
              <br />
              {product.default_category && (
                <>
                  <br />
                  {product.default_category.name}
                </>
              )}
              <RegularButton
                className={classes.saveButton}
                color="info"
                fullWidth
                disabled={!amSoDirty}
                size="sm"
                onClick={() => this.handleUpdateProduct()}
              >
                {saved ? "saved" : "save changes"}
              </RegularButton>
              <RegularButton
                className={classes.saveButton}
                color="danger"
                fullWidth
                size="sm"
                onClick={() => this.handleClose()}
              >
                Cancel
              </RegularButton>
            </div>
            <div className={`${margin.top_sm} ${classes.rightContainer}`}>
              <AppBar position="static">
                <Tabs
                  value={tabIndex}
                  onChange={(e, newValue) =>
                    this.setState({ tabIndex: newValue })
                  }
                  aria-label="simple tabs example"
                >
                  {
                    tabNames.map((label)=>{
                      return (<Tab label={label} />);
                    })
                  }
                </Tabs>
              </AppBar>
              <TabPanel value={tabIndex} index={4}>
                <div>{this.placementTab(product.top_pick_override)}</div>
              </TabPanel>
              {
                recommendationOptions.map((value, idx)=>{
                  return (
                    <TabPanel value={tabIndex} index={idx}>
                      <div>{this.recommendedTab(value)}</div>
                    </TabPanel>
                  );
                })
              }
            </div>
          </div>
        </div>
      </Dialog>
    );
  }
}

export default connect((state) => ({
  currentUser: state.app.user,
}))(withStyles(styles)(GlobalProductModal));
